// extracted by mini-css-extract-plugin
export default {"shareToggle":"ShareToggleModal_shareToggle__uoHnQ","emailTab":"ShareToggleModal_emailTab__iFia9","btn":"ShareToggleModal_btn__s-dwY"};